import React, { useState, useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import Answer from './details';
import s from './index.module.scss';
import common from '../../index.module.scss';
import expert1 from './img/expert_1.jpg';
import expert2 from './img/expert_2.jpg';
import certificetes from './img/certificates.png';

function MedicineExperts () {
	const { T } = useT();
	const [showAnswerToUser, setShowAnswer] = useState(false);

	const answers = {
		1: {
			title: window.locales.expert_1_title,
			text: window.locales.expert_1_content
		},
		2: {
			title: window.locales.expert_2_title,
			text: window.locales.expert_2_content
		}
	};

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'medicine_experts',
			stepStatus: true
		});
	}, []);

	function showAnswer (answer) {
		setShowAnswer(answer);
	}

	return (
		<>
			<div className={`${s.medicineExperts} ${common.step}`}>
				<h1 className={common.stepTitle}>{T('experts_title')}</h1>
				<div className={common.stepDescription}>{T('experts_description')}</div>
				<ul className={s.experts}>
					<li className={s.expert}>
						<div className={s.leftColumn}>
							<img className={s.img} src={expert1} alt="" />
						</div>
						<div className={s.rightColumn}>
							<h2 className={s.expertTitle}>{T('expert_1_name')}</h2>
							<div className={s.expertDescription}>{T('expert_1_description')}</div>
							<blockquote className={s.expertQuote}>{T('expert_1_quote')}</blockquote>
							<button
								className={s.button}
								type="button"
								onClick={() => {
									showAnswer(answers[1]);
								}}
							>
								{T('expert_1_button')}
							</button>
						</div>
					</li>
					<li className={s.expert}>
						<div className={s.leftColumn}>
							<img className={s.img} src={expert2} alt="" />
						</div>
						<div className={s.rightColumn}>
							<h2 className={s.expertTitle}>{T('expert_2_name')}</h2>
							<div className={s.expertDescription}>{T('expert_2_description')}</div>
							<blockquote className={s.expertQuote}>{T('expert_2_quote')}</blockquote>
							<button
								className={s.button}
								type="button"
								onClick={() => {
									showAnswer(answers[2]);
								}}
							>
								{T('expert_2_button')}
							</button>
						</div>
					</li>
				</ul>
				<img className={s.certificates} src={certificetes} alt="" />
			</div>
			{showAnswerToUser && (
				<Answer
					onClickBack={() => {
						setShowAnswer(false);
					}}
					answerData={showAnswerToUser}
				/>
			)}
		</>
	);
}

export default MedicineExperts;
